<template>
  <section
    class="author-section"
    v-if="
      authorData &&
      Object.keys(authorData).length > 0 &&
      authorData.data &&
      authorData.data.length > 0
    "
  >
    <div class="container">
      <template
        v-if="
          authorData.style === 'big' &&
          !(authorData.data.filter((ele) => ele.description === '').length > 0)
        "
      >
        <div
          :class="{
            'author-wrapper-big-card': true,
            'full-card': authorData.move_author_description_below,
          }"
          v-for="(data, index) in authorData.data"
          :key="'desk' + index"
        >
          <div
            :class="{
              'author-img': true,
              'full-card-img': authorData.move_author_description_below,
            }"
          >
            <img
              :src="data.user_avatar_url"
              width="100"
              height="100"
              :alt="getAltText('', data.user_avatar_url)"
            />
            <div class="author-img-content">
              <div>
                 <template
                    v-if="data.profile_data.slug === '' && data.profile_data.post_type === ''"
                  >
                  <span class="span-h2 author-desktop-version">{{
                    data.display_name
                  }}</span>
                  <p class="mob-nam author-mobile-version">
                    {{ data.display_name }}
                  </p>
                 </template>
                 <template v-else>
                    <a :href="getRouteLink(data.profile_data.slug,data.profile_data.post_type)">
                      <span class="span-h2 author-desktop-version">{{
                        data.display_name
                      }}</span>
                      <p class="mob-nam author-mobile-version">
                        {{ data.display_name }}
                      </p>
                    </a>
                 </template>
                <span class="span-title">{{ data.role_title }}</span>
              </div>
              <a
                :title="data.display_name"
                v-if="
                  data.social_links &&
                  Object.keys(data.social_links).length > 0 &&
                  data.social_links.linkedin &&
                  data.social_links.linkedin != ''
                "
                :href="data.social_links.linkedin"
                target="_blank"
                rel="no-follow"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.1354 0C1.41118 0 0 1.41114 0 3.1354V12.8651C0 14.5893 1.41114 16 3.1354 16H12.8651C14.5894 16 16 14.5894 16 12.8651V3.1354C16 1.41118 14.5894 0 12.8651 0H3.1354ZM3.924 2.64032C4.75073 2.64032 5.25996 3.18306 5.27568 3.89647C5.27568 4.59414 4.7507 5.15212 3.90801 5.15212H3.8925C3.08151 5.15212 2.55733 4.59417 2.55733 3.89647C2.55733 3.18307 3.09737 2.64032 3.92399 2.64032H3.924ZM11.0484 5.97474C12.6384 5.97474 13.8303 7.01394 13.8303 9.24714V13.4162H11.4139V9.52666C11.4139 8.54927 11.0642 7.88245 10.1898 7.88245C9.52224 7.88245 9.12434 8.3319 8.94964 8.76607C8.88582 8.9214 8.87013 9.13834 8.87013 9.35564V13.4162H6.45383C6.45383 13.4162 6.48554 6.82746 6.45383 6.14525H8.87063V7.17488C9.19173 6.67946 9.76609 5.97472 11.0484 5.97472V5.97474ZM2.69985 6.14577H5.11616V13.4162H2.69985V6.14577Z"
                    fill="black"
                  />
                </svg>
              </a>
            </div>
          </div>
          <div
            :class="{
              'author-content': true,
              'full-card-content': authorData.move_author_description_below,
            }"
          >
            <span class="span-h5">{{ $root.i18n.about_the_author }}</span>
            <p>{{ data.description }}</p>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="row">
          <div
            class="col-lg-3"
            v-for="(data, index) in authorData.data"
            :key="'desk' + index"
          >
            <div class="author-wrapper-small-card">
              <img
                :src="data.user_avatar_url"
                width="100"
                height="100"
                :alt="getAltText('', data.user_avatar_url)"
              />
              <div class="author-img-content">
                <div class="inner-wrap">
                  <template
                    v-if="data.profile_data.slug === '' && data.profile_data.post_type === ''"
                  >
                  <p class="p-bold">
                      {{ data.display_name }}
                  </p>
                  </template>
                  <template v-else>
                    <a :href="getRouteLink(data.profile_data.slug,data.profile_data.post_type)">
                      <p class="p-bold">
                        {{ data.display_name }}
                      </p>
                    </a>
                  </template>
                  <a
                    :title="data.display_name"
                    v-if="
                      data.social_links &&
                      Object.keys(data.social_links).length > 0 &&
                      data.social_links.linkedin &&
                      data.social_links.linkedin != ''
                    "
                    :href="data.social_links.linkedin"
                    target="_blank"
                    rel="no-follow"
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.1354 0C1.41118 0 0 1.41114 0 3.1354V12.8651C0 14.5893 1.41114 16 3.1354 16H12.8651C14.5894 16 16 14.5894 16 12.8651V3.1354C16 1.41118 14.5894 0 12.8651 0H3.1354ZM3.924 2.64032C4.75073 2.64032 5.25996 3.18306 5.27568 3.89647C5.27568 4.59414 4.7507 5.15212 3.90801 5.15212H3.8925C3.08151 5.15212 2.55733 4.59417 2.55733 3.89647C2.55733 3.18307 3.09737 2.64032 3.92399 2.64032H3.924ZM11.0484 5.97474C12.6384 5.97474 13.8303 7.01394 13.8303 9.24714V13.4162H11.4139V9.52666C11.4139 8.54927 11.0642 7.88245 10.1898 7.88245C9.52224 7.88245 9.12434 8.3319 8.94964 8.76607C8.88582 8.9214 8.87013 9.13834 8.87013 9.35564V13.4162H6.45383C6.45383 13.4162 6.48554 6.82746 6.45383 6.14525H8.87063V7.17488C9.19173 6.67946 9.76609 5.97472 11.0484 5.97472V5.97474ZM2.69985 6.14577H5.11616V13.4162H2.69985V6.14577Z"
                        fill="black"
                      />
                    </svg>
                  </a>
                </div>
                <span class="span-caption">{{ data.role_title }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </section>
</template>
<script>
export default {
  name: "Author",
  props: ["authorData"],
};
</script>
<style lang="less">
@import "~@/assets/less/base/variable";

.author {
  &-section {
    //padding-bottom: 25px;
  }
  &-wrapper-big-card {
    display: flex;
    flex-direction: column;
    .border-radius(10px);
    margin-bottom: 10px;
    background: @white;
    padding: 16px;
    @media (min-width: @sizes[small]) {
      flex-direction: row;
    }
    .author-img {
      display: flex;
      margin-right: 10px;
      @media (min-width: @sizes[small]) {
        width: 50%;
      }
      img {
        width: 70px;
        height: 70px;
        .border-radius(10px);
        margin-right: 16px;
        @media (min-width: @sizes[small]) {
          width: 100px;
          height: 100px;
        }
      }
      &-content {
        line-height: 18px;
        height: 70px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        @media (min-width: @sizes[small]) {
          height: 100px;
        }
        .span-h2 {
          margin: 0;
          line-height: 32px;
        }
        p.mob-nam {
          margin: 0;
          font-weight: 700;
        }
        .span-title {
          color: #9b9b9b;
        }
        a {
          cursor: pointer;
        }
      }
    }
    .author-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      @media (min-width: @sizes[small]) {
        width: calc(50% - 10px);
      }
      @media (max-width: @sizes[small]) {
        margin-top: 16px;
      }
      .span-h5 {
        margin: 0;
      }
      p {
        margin: 0;
      }
    }
  }
  &-wrapper-small-card {
    display: flex;
    flex-direction: row;
    .border-radius(10px);
    margin-bottom: 16px;
    margin-right: 10px;
    img {
      width: 40px;
      height: 40px;
      .border-radius(50%);
      margin-right: 16px;
    }
    .author-img-content {
      line-height: 18px;
      display: flex;
      flex-direction: column;
      .inner-wrap {
        display: flex;
        flex-direction: row;
        align-items: center;
        a{
          width:auto;
          height:auto;
          margin-left:0;
        }
      }
      .p-bold {
        margin: 0;
        font-weight: 700;
      }
      .span-caption {
        color: #9b9b9b;
        line-height: 10px;
      }
      a {
        cursor: pointer;
        margin-left: 8px;
        width: 16px;
        height: 16px;
      }
    }
  }
  &-desktop-version {
    display: none;
    @media (min-width: @sizes[small]) {
      display: flex;
    }
  }
  &-mobile-version {
    display: flex;
    @media (min-width: @sizes[small]) {
      display: none;
    }
  }
}

.full-card {
  @media (min-width: @sizes[medium]) {
    flex-direction: column !important;
    &-img {
      width: 100% !important;
      margin-right: 0px !important;
    }
    &-content {
      width: 100% !important;
      margin-top: 10px !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/custom-block/Author.vue